<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <label for="active">
          {{ $t('common.routing.active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="active" :disabled="readonly" id="active"
          :aria-label="$t('common.routing.active')">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0" selected> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" disabled :isMandatory="tb == '1'"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="(readonly) || (tb == '1')"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input  v-model="timeout" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.timeout')" :placeholderValue="$t('common.routing.timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''  && tb != '1'">
        <form-write-group-label-input v-model="formatName" disabled
          :inputLabel="$t('common.routing.format_name')" :placeholderValue="$t('common.routing.format_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group mt-4" v-if="tb == '1'">
        <span class="my-2">
          <span class="filter-item-title">{{ $t('certificates.details_certificate') }}</span>
          <span class="color-red">* </span>
        </span>
        <br>
        <b-col sm="12 my-2">
          <b-col sm="12 p-0 my-3">
            <input v-if="!readonly" class="p-0" type="file" @change="handleFileUploadCertificat($event)" accept=".crt" />
          </b-col>
          <b-col sm="6" class="my-3 p-0">
            <b-button v-if="!readonly" class="justify-item-end responsive-button"
                      @click="openPopup('output')" variant="primary">
              <i class="fa-light fa-plus "></i>
              <span>{{$t('entities_setting_tb.generate_certificat')}}</span>
            </b-button>
          </b-col>
          <certificate-pop-up v-if="showModal" @close="closePopup" @savepopup="submitForm" :form="form" ></certificate-pop-up>
          <br>
          <!-- Affichage des données extraites -->
          <b-col sm="12" class="p-0" v-if="CertificateInput">
            <b-row class="m-0">
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.deliveredTo !== ''"
                    :inputLabel="$t('certificates.common_name')"
                    :inputValue="CertificateInput.deliveredTo">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.deliveredBy !== ''"
                    :inputLabel="$t('certificates.issued_by')"
                    :inputValue="CertificateInput.deliveredBy">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.startDate !== ''"
                    :inputLabel="$t('certificates.valid_from')"
                    :inputValue="CertificateInput.startDate">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.endDate !== ''"
                    :inputLabel="$t('certificates.valid_until')"
                    :inputValue="CertificateInput.endDate">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="p-0" v-else>
            <b-row class="m-0">
              <b-col sm="12" class="p-0">
                <div class="d-flex justify-content-center">
                      <span class="noResult">
                        {{ $t('common.no_certificate') }}
                      </span>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="p-0" v-if="CertificateInput">
            <!-- Affichage du certificat au format PEM -->
            <details class="mt-3 w-100">
              <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_certificate') }}</summary>
              <pre class="p-2 bg-light text-monospace">{{ CertificateInput.certificate }}</pre>
            </details>
          </b-col>
        </b-col>
        <!-- Affichage des données extraites -->
      </b-col>
      <b-col sm="6" v-if="tb == '1'" class="form-group d-flex flex-column mt-4">
        <br>
        <!-- Détails de l'Autorité de Certification -->
        <div v-if="CAServer" class="certificate-details">
          <span>
            <span class="filter-item-title">{{ $t('certificates.details_ca_server') }}</span>
            <span class="color-red">* </span>
          </span>
          <br>
          <b-col  sm="12" v-if="CertificatServerParsed" class="certificate-details">
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col sm="12">
                <!-- Affichage des certificats CA concaténés -->
                <details class="mt-4">
                  <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_ca_certificates') }}</summary>
                  <pre class="p-2 bg-light text-monospace">{{ CAServer }}</pre>
                </details>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>

      <certificate-pop-up v-if="showModal && tb == '1'" @close="closePopup" @savepopup="submitForm" :form="form" ></certificate-pop-up>
<!--      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''">-->
<!--        <form-write-group-label-input :input-value="formatOutName" disabled-->
<!--          :inputLabel="$t('common.routing.format_out_name')" :placeholderValue="$t('common.routing.format_out_name')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <label for="ssl-active">
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">
          <option v-if="sslActive != '0'" :value="sslActive"> {{ $t('common.routing.yes') }} </option>
          <option v-else value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0"> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col v-if="sslActive != '0' && tb != '1'" sm="6" class="form-group">
        <label for="keystore">
          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">
          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.name }} </option>
        </select>
      </b-col>
      <b-col sm="6" v-if="sslActive != '0' && tb != '1'" class="form-group">
        <label for="ca">
          {{ $t('common.routing.certificat') }}
<!--          <span class="color-red"> * </span>-->
        </label>
        <select class="form-control" v-model="ca" :disabled="readonly" id="ca">
          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.name }} </option>
        </select>
      </b-col>
    </b-row>
    <level-control-form v-if="sslActive === '1'  && tb != '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>
    <form-accordion v-if="ExtractDataFromCertificat !== ''" :title="$t('common.global.authentification_certificat')" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="ExtractDataFromCertificat" isMandatory disabled
            :inputLabel="$t('common.routing.extract_data_from_certificat')" :placeholderValue="$t('common.routing.extract_data_from_certificat')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>
    <form-accordion v-if="ExtractDataFromHeader !== '' && tb != '1'" :title="$t('common.global.authentification_header')" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="ExtractDataFromHeader" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.extract_data_from_header')" :placeholderValue="$t('common.routing.extract_data_from_header')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>
    <form-accordion :title="$t('common.vop_provider.vop_provider')" :isTitleUpperCase="false" v-if="entitiesType === 'rvm' && tb != '1'">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="vopProvider">
            {{ $t('common.vop_provider.name') }}
          </label>
          <select class="form-control" v-model="IdVopProvider" :disabled="readonly"  id="vopProvider">
            <option value="" hidden disabled> {{ $t('common.routing.select_name_vop_provider') }} </option>
            <option v-for="vopProvider in vopProviderList" :key="vopProvider.id" :value="vopProvider.id">
              {{ vopProvider.text }}
            </option>
          </select>
        </b-col>
      </b-row>
    </form-accordion>
  </div>
</template>
<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import {errorMessageAlert} from '@/helpers/alert'
import forge from "node-forge";
import CertificatePopUp from "@/popups/security/CertificatePopUp.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    FormReadGroupLabelInput,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'certificate-pop-up': CertificatePopUp
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    tb: {
      type: String,
      default: "0"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    CertificatServer: {
    },
    CAServer: {
    },

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    active: {
      get () {
        return this.inputValue.active
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: val,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    formatName: {
      get () {
        return this.inputValue.formatName
      },
      set (val) {
        this.inputValue = {
          formatName: val,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    formatOutName: {
      get () {
        return this.inputValue.formatOutName
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: val,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    host: {
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: val,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    port: {
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: val,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: val,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    keystore: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.keystore
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: val,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    ca: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.ca
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    timeout:{
      get () {
        return this.inputValue.timeout
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: val,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    ExtractDataFromCertificat:{
      get () {
        return this.inputValue.ExtractDataFromCertificat
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: val,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    IdAuthCert:{
      get () {
        return this.inputValue.IdAuthCert
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: val,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    ExtractDataFromHeader:{
      get () {
        return this.inputValue.ExtractDataFromHeader
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: val,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    IdAuthHeader:{
      get () {
        return this.inputValue.IdAuthHeader
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: val,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    IdVopProvider:{
      get () {
        return this.inputValue.IdVopProvider === undefined ? '' : this.inputValue.IdVopProvider
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: val,
          Cert: this.inputValue.Cert
        }
      }
    },
    Cert:{
      get () {
        return this.inputValue.Cert === undefined ? '' : this.inputValue.Cert
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          active: this.inputValue.active,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          ExtractDataFromCertificat: this.inputValue.ExtractDataFromCertificat,
          IdAuthCert: this.inputValue.IdAuthCert,
          ExtractDataFromHeader: this.inputValue.ExtractDataFromHeader,
          IdAuthHeader: this.inputValue.IdAuthHeader,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: val
        }
      }
    }
  },
  data () {
    return {
      caList: [],
      keystoreList: [],
      vopProviderList: [],
      CertificateInput: null,
      CertificatServerParsed: null,
      form: {
        C: "",
        O: "",
        CN: "",
        LEI: "",
        subjectAltName: "",
        mode: "clientAuth",
        L: "",
        VAT: ""
      },
      isSubjectAltNameEditable: true,
      showModal: false,
      modeOptions: [
        { value: "clientAuth", text: "Client Auth" },
        { value: "serverAuth", text: "Server Auth" }
      ]
    }
  },
  created () {
    this.entitiesType = ''
    if (this.tb != '1') {
      this.entitiesType = this.$route.params.entitiesType
      if (this.mode === 'create') {
        if (this.prefilledURI !== undefined || this.prefilledURI === '') {
          this.inputValue.uri = this.prefilledURI
        }
        this.inputValue.sslActive = '0'
      }
      this.getCA()
      this.getKeyStore()
      this.getVopProvider()
    }else{
      this.CertificatServerParsed = this.parseCertificate(this.CAServer)
      if(this.CertificatServer != '$NotFound' || this.CertificatServer != '') {
        this.CertificateInput = this.parseCertificate(this.CertificatServer)
      }
    }
  },
  methods: {
    openPopup() {
      this.showModal = true
    },
    closePopup() {
      this.showModal = false
    },
    submitForm() {
      let that = this

      this.$engine.firstOn().routing.config.webService.generateCertificatQwacLike(this.form)
          .then(resp => {
            if (!resp.data.certificate || !resp.data.key) {
              console.error("❌ Erreur : Certificat ou clé privée manquants !")
              return
            }

            // Décoder le Base64
            const decodedCert = atob(resp.data.certificate)
            const decodedKey = atob(resp.data.key)


            // Téléchargement des fichiers
            that.downloadBase64File(resp.data.certificate, 'certificat.crt', 'application/x-x509-ca-cert')
            that.downloadBase64File(resp.data.key, 'private_key.key', 'application/x-pem-file')
            that.closePopup()


            try {
              const certificate = forge.pki.certificateFromPem(decodedCert)
              const pemFormattedCert = forge.pki.certificateToPem(certificate)

              this.inputValue.CertificateText = pemFormattedCert

              // Formatage des dates (YYYY-MM-DD)
              const startDate = certificate.validity.notBefore.toISOString().split('T')[0]
              const endDate = certificate.validity.notAfter.toISOString().split('T')[0]

              // Fonction pour récupérer les valeurs des attributs
              const getAttributeValue = (attributes, name) => {
                const attr = attributes.find(attr => attr.name === name)
                return attr ? attr.value : 'Inconnu'
              }

              // Récupération des informations
              const deliveredBy = getAttributeValue(certificate.issuer.attributes, 'commonName')
              const deliveredTo = getAttributeValue(certificate.subject.attributes, 'commonName')

              // Création de l'objet CertificateInput
              const CertificateInput = {
                certificate: pemFormattedCert,  // Contenu du certificat en PEM
                startDate,                      // Date de début de validité
                endDate,                        // Date de fin de validité
                deliveredBy,                    // Émetteur du certificat
                deliveredTo,                    // Destinataire (CN)
                nameDisplay: deliveredTo         // Affichage du nom (même que deliveredTo)
              }

              // Mise à jour de la data en fonction de index
              this.CertificateInput = CertificateInput
              this.inputValue.Cert = decodedCert



            } catch (err) {
              console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
            }
          })
          .catch(e => {
            errorMessageAlert(e, that)
            that.okMessageBox(that.$t('common.routing.config_addition_error'))
          })
    },
    downloadBase64File(base64Data, filename, mimeType) {
      let linkSource = `data:${mimeType}base64,` + base64Data
      let downloadLink = document.createElement('a')

      // Vérification si mobile
      if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
        downloadFileWithDefinedHeaders(this, filename, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = filename
        downloadLink.click()
      }
    },
    handleFileUploadCertificat(event, index = null) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const pemContent = e.target.result

        try {
          const certificate = forge.pki.certificateFromPem(pemContent)
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          this.inputValue.CertificateText = pemFormattedCert

          // Formatage des dates (YYYY-MM-DD)
          const startDate = certificate.validity.notBefore.toISOString().split('T')[0]
          const endDate = certificate.validity.notAfter.toISOString().split('T')[0]

          // Fonction pour récupérer les valeurs des attributs
          const getAttributeValue = (attributes, name) => {
            const attr = attributes.find(attr => attr.name === name)
            return attr ? attr.value : 'Inconnu'
          }

          // Récupération des informations
          const deliveredBy = getAttributeValue(certificate.issuer.attributes, 'commonName')
          const deliveredTo = getAttributeValue(certificate.subject.attributes, 'commonName')

          // Création de l'objet CertificateInput
          const CertificateInput = {
            certificate: pemFormattedCert,  // Contenu du certificat en PEM
            startDate,                      // Date de début de validité
            endDate,                        // Date de fin de validité
            deliveredBy,                    // Émetteur du certificat
            deliveredTo,                    // Destinataire (CN)
            nameDisplay: deliveredTo         // Affichage du nom (même que deliveredTo)
          }

          // Mise à jour de la data en fonction de index
          if (index == null) {
            this.CertificateInput = CertificateInput  // Stockage unique
            this.inputValue.Cert = pemContent
          } else {
            this.inputValue.CertificatList[index] = CertificateInput  // Mise à jour d'une liste
          }


        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
        }
      }


      reader.readAsText(file)
    },
    getCA () {
      let that =this
      this.$engine.firstOn().security.ca.fetch()
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca
        this.caList = CAList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getKeyStore () {
      let that = this
      this.$engine.firstOn().security.keystore.fetch()
      .then(resp => {
        let privateKeysList = {}

        privateKeysList = resp.data.keystore

        this.keystoreList = privateKeysList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.firstOn().vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          id: vopProvider.IdVopProvider,
          text: vopProvider.NameVopProvider,
          value: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    parseCertificate (pemCert) {
      try {
        const cert = forge.pki.certificateFromPem(pemCert)
        return {
          certificate: pemCert,  // Contenu du certificat en PEM
          startDate: cert.validity.notBefore.toISOString().split('T')[0],
          endDate: cert.validity.notAfter.toISOString().split('T')[0],
          deliveredBy: this.getAttributeValue(cert.issuer.attributes, 'commonName'),
          deliveredTo: this.getAttributeValue(cert.subject.attributes, 'commonName'),
        };
      } catch (err) {
        console.error("Erreur de parsing du certificat :", err);
        return null;
      }
    },
    getAttributeValue (attributes, name) {
      const attr = attributes.find(attr => attr.name === name);
      return attr ? attr.value : 'Inconnu';
    }
  }
}

</script>
